export default __webpack_public_path__ + "static/media/ephemeral_1.5a7e04d7.png";